import { combineReducers } from 'redux'
import apiReducer from './api';

// const data = (state = { }, action) => {
// 	/* some code here */
// 	//console.log(state);
// 	//console.log(action);
// 	if( action.response ) state = action.response;
// 	return state;	
// }

const rootReducer = combineReducers({ data: apiReducer });

export default rootReducer


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/